// The sign-up form's message for errors that don't belong to the name, email or password fields (Josh, 10 Oct 2026: a
// failed sign-up showed nothing at all). Field errors return '' because the form shows those under their own field.
const FIELD_ERRORS = ['auth/invalid-email', 'auth/email-already-in-use', 'auth/weak-password', 'invalid-firstName', 'invalid-lastName'];

export default function registerErrorMessage(code) {
    if (!code || FIELD_ERRORS.indexOf(code) !== -1) return '';
    switch (code) {
    case 'auth/admin-restricted-operation':
    case 'auth/operation-not-allowed':
        // Josh, 10 Oct: say where to go for help, e.g. someone invited to staging while sign-up there is switched off.
        return 'New accounts can’t be created here. If you believe you are seeing this in error, please contact support@thecuelist.com.';
    case 'auth/network-request-failed':
        return 'Couldn’t reach Cuelist. Check your connection and try again.';
    case 'auth/too-many-requests':
        return 'Too many attempts. Wait a few minutes and try again.';
    default:
        return 'Your account couldn’t be created. Please try again, or contact support@thecuelist.com if it keeps happening.';
    }
}


// WEBPACK FOOTER //
// ./src/lib/register-error-message.js